export const FETCH_AGE_RATINGS = "FETCH_AGE_RATINGS";
